import React from "react";
import Layout from "../Layout";
import AccountLayout from "./AccountLayout";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";

const Refrel = () => {
  const { t } = useTranslation();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const navigate = useNavigate();
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t("ReferFriendTitle"),
          text: t("ReferFriendText"),
          url: `https://${window.location.hostname}/register?referral_code=${profileData?.referalCode}`,
        });
        console.log("Shared successfully");
      } catch (error) {
        console.log("Error sharing:", error);
      }
    } else {
      alert(t("ShareNotSupported"));
    }
  };
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(
        `https://${window.location.hostname}/register?referral_code=${profileData?.referalCode}`,
      )
      .then(() => {
        toast.success(t("CopiedClipboard"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  return (
    <AccountLayout title={t("Referral")}>
      {/* <ng-component
        _nghost-serverapp-c218240816=""
        class="ng-tns-c218240816-13 ng-star-inserted"
        style={{}}
      >
        <div
          _ngcontent-serverapp-c218240816=""
          className="referral-entry ng-tns-c218240816-13 ng-trigger ng-trigger-tabPageTriggerAni"
        >
          <router-outlet
            _ngcontent-serverapp-c218240816=""
            class="ng-tns-c218240816-13"
          />
          <ng-component
            _nghost-serverapp-c1696643091=""
            class="ng-tns-c1696643091-17 ng-star-inserted"
            style={{}}
          >
            <div
              _ngcontent-serverapp-c1696643091=""
              className="referral-information inner-box ng-tns-c1696643091-17 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c1696643091=""
                className="referral-information__head ng-tns-c1696643091-17"
              >
                <div
                  _ngcontent-serverapp-c1696643091=""
                  className="referral-information__banner ng-tns-c1696643091-17"
                >
                  <img
                    _ngcontent-serverapp-c1696643091=""
                    alt="referral-banner"
                    className="ng-tns-c1696643091-17 ng-star-inserted"
                    loading="eager"
                    src="/assets/images/referral-program-banner.png"
                    style={{}}
                  />
                </div>
              </div>
              <div
                _ngcontent-serverapp-c1696643091=""
                className="recommend-friends-box ng-tns-c1696643091-17"
              >
                <div
                  _ngcontent-serverapp-c1696643091=""
                  className="referral-information__panel referral-information-panel referral-terms-panel ng-tns-c1696643091-17"
                />
                <div
                  _ngcontent-serverapp-c1696643091=""
                  className="code-box referral-information__panel referral-information-panel referral-code-panel ng-tns-c1696643091-17"
                >
                  <qrcode
                    _ngcontent-serverapp-c1696643091=""
                    className="referral-code-panel__qrcode referral-code-panel-qrcode ng-tns-c1696643091-17 ng-star-inserted"
                    style={{}}
                  >
                    <div className="referral-code-panel-qrcode__inner">
                      <QRCodeCanvas
                        value={`https://${window.location.hostname}/register?referral_code=${profileData?.referalCode}`}
                        size={100}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                      />
                    </div>
                  </qrcode>
                  <div
                    _ngcontent-serverapp-c1696643091=""
                    className="referral-code-panel__title ng-tns-c1696643091-17"
                  >
                    {" "}
                    {t("YourReferralCode")}{" "}
                  </div>
                  <div
                    _ngcontent-serverapp-c1696643091=""
                    className="referral-code-panel__code code-panel-area ng-tns-c1696643091-17"
                  >
                    <span
                      style={{ color: "white" }}
                      _ngcontent-serverapp-c1696643091=""
                      className="code-panel-area__code ng-tns-c1696643091-17"
                    >
                      {profileData?.referalCode}
                    </span>
                    <span
                      onClick={() => copyToClipboard()}
                      _ngcontent-serverapp-c1696643091=""
                      className="code-panel-area__icon ng-tns-c1696643091-17"
                      style={{
                        maskImage: 'url("/assets/images/icon-copy.svg")',
                      }}
                    />
                  </div>
                  <div
                    _ngcontent-serverapp-c1696643091=""
                    className="referral-code-panel__btn-wrap ng-tns-c1696643091-17"
                  >
                    <div
                      _ngcontent-serverapp-c1696643091=""
                      className="referral-code-panel__btn referral-code-panel__btn-link ng-tns-c1696643091-17"
                      onClick={() => copyToClipboard()}
                    >
                      {" "}
                      {t("CopyLink")}{" "}
                    </div>
                    <div
                      onClick={() => handleShare()}
                      _ngcontent-serverapp-c1696643091=""
                      className="referral-code-panel__btn ng-tns-c1696643091-17 ng-star-inserted"
                      style={{}}
                    >
                      {" "}
                      {t("Share")}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-component>
        </div>
      </ng-component> */}

      <div
        _ngcontent-serverapp-c2092938168
        className="ng-tns-c2092938168-17 ng-trigger ng-trigger-tabPageTriggerAni"
      >
        <router-outlet
          _ngcontent-serverapp-c2092938168
          className="ng-tns-c2092938168-17"
        />
        <mcd-referral-invite-mobile
          className="ng-tns-c677469450-25 ng-star-inserted"
          style={{}}
        >
          <div className="referral-partner ng-tns-c677469450-25 ng-star-inserted">
            <mcd-invitation-link
              _nghost-serverapp-c2798261857
              className="ng-tns-c2798261857-26 ng-tns-c677469450-25 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c2798261857
                className="menu-box invitation-link ng-tns-c2798261857-26 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c2798261857
                  className="title ng-tns-c2798261857-26"
                >
                  <h2
                    _ngcontent-serverapp-c2798261857
                    className="ng-tns-c2798261857-26"
                  >
                    <span
                      _ngcontent-serverapp-c2798261857
                      className="ng-tns-c2798261857-26"
                    >
                      Refer Your Friends and Earn
                    </span>
                  </h2>
                </div>
                <div
                  _ngcontent-serverapp-c2798261857
                  className="code-box ng-tns-c2798261857-26"
                >
                  <div
                    _ngcontent-serverapp-c2798261857
                    className="invite-banner ng-tns-c2798261857-26"
                  >
                    <img
                      _ngcontent-serverapp-c2798261857
                      className="ng-tns-c2798261857-26"
                      alt="referral-invite-banner-bdt-en"
                      src="https://img.b426b.com/bb/h5/assets/images/player/referral/referral-invite-banner-bdt-en.png?v=1777968966408&source=mcdsrc"
                      loading="lazy"
                    />
                  </div>
                  <div
                    _ngcontent-serverapp-c2798261857
                    className="invite-cont ng-tns-c2798261857-26 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c2798261857
                      className="left ng-tns-c2798261857-26"
                    >
                      <div
                        _ngcontent-serverapp-c2798261857
                        className="bonus-title ng-tns-c2798261857-26"
                      >
                        {" "}
                        Invitation QR Code{" "}
                      </div>
                      <div
                        _ngcontent-serverapp-c2798261857
                        className="invite-qr-code ng-tns-c2798261857-26"
                      >
                        <div
                          _ngcontent-serverapp-c2798261857
                          className="qr-code ng-tns-c2798261857-26"
                        >
                           <QRCodeCanvas
                        value={`https://${window.location.hostname}/register?referral_code=${profileData?.referalCode}`}
                        size={100}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                      />
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c2798261857
                      className="right ng-tns-c2798261857-26"
                    >
                      <div
                        _ngcontent-serverapp-c2798261857
                        className="bonus-title ng-tns-c2798261857-26"
                      >
                        {" "}
                        Invitation Link{" "}
                      </div>
                      <div  onClick={() => handleShare()}
                        _ngcontent-serverapp-c2798261857
                        className="btn-share ng-tns-c2798261857-26 ng-star-inserted"
                      >
                        {" "}
                        Share{" "}
                      </div>

                      <div
                        _ngcontent-serverapp-c2798261857
                        className="bonus-title ng-tns-c2798261857-26"
                      >
                        {" "}
                        Invitation Code{" "}
                      </div>
                      <div
                        _ngcontent-serverapp-c2798261857
                        className="code ng-tns-c2798261857-26"
                      >
                        <span
                          _ngcontent-serverapp-c2798261857
                          className="ng-tns-c2798261857-26"
                        >
                           {profileData?.referalCode}
                        </span>
                        <div  onClick={() => copyToClipboard()}
                          _ngcontent-serverapp-c2798261857
                          className="btn ng-tns-c2798261857-26"
                        >
                          <img
                            _ngcontent-serverapp-c2798261857
                            className="ng-tns-c2798261857-26"
                            alt="icon-copy-type02"
                            src="https://img.b426b.com/bb/h5/assets/images/icon-set/icon-copy-type02.svg?v=1777968966408&source=mcdsrc"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mcd-invitation-link>

            {/* <mcd-received-bonus-record
              _nghost-serverapp-c2698320047
              className="ng-tns-c2698320047-27 ng-tns-c677469450-25 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c2698320047
                className="menu-box received-bonus-record ng-tns-c2698320047-27 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c2698320047
                  className="invite-box ng-tns-c2698320047-27"
                >
                  <div
                    _ngcontent-serverapp-c2698320047
                    className="item ng-tns-c2698320047-27"
                  >
                    <div
                      _ngcontent-serverapp-c2698320047
                      className="invite-title ng-tns-c2698320047-27"
                    >
                      {" "}
                      Referral Count{" "}
                    </div>
                    <div
                      _ngcontent-serverapp-c2698320047
                      className="text ng-tns-c2698320047-27"
                    >
                      {" "}
                      0{" "}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2698320047
                    className="item ng-tns-c2698320047-27"
                  >
                    <div
                      _ngcontent-serverapp-c2698320047
                      className="invite-title ng-tns-c2698320047-27"
                    >
                      {" "}
                      Today’s Rewards{" "}
                    </div>
                    <div
                      _ngcontent-serverapp-c2698320047
                      className="text ng-tns-c2698320047-27"
                    >
                      <i
                        id="locale-util-dicrective-7"
                        className="ng-tns-c2698320047-27"
                        style={{ display: "initial" }}
                      >
                        ৳ 0
                      </i>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2698320047
                    className="item ng-tns-c2698320047-27"
                  >
                    <div
                      _ngcontent-serverapp-c2698320047
                      className="invite-title ng-tns-c2698320047-27"
                    >
                      {" "}
                      Yesterday’s Rewards{" "}
                    </div>
                    <div
                      _ngcontent-serverapp-c2698320047
                      className="text ng-tns-c2698320047-27"
                    >
                      <i
                        id="locale-util-dicrective-8"
                        className="ng-tns-c2698320047-27"
                        style={{ display: "initial" }}
                      >
                        ৳ 0
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </mcd-received-bonus-record>

            <mcd-can-receive-bonus
              _nghost-serverapp-c2101316294
              className="ng-tns-c2101316294-28 ng-tns-c677469450-25 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c2101316294
                className="menu-box can-receive-bonus ng-tns-c2101316294-28 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c2101316294
                  className="title ng-tns-c2101316294-28"
                >
                  <h2
                    _ngcontent-serverapp-c2101316294
                    className="ng-tns-c2101316294-28"
                  >
                    <span
                      _ngcontent-serverapp-c2101316294
                      className="ng-tns-c2101316294-28"
                    >
                      Available Cash Rewards
                    </span>
                  </h2>
                </div>
                <div
                  _ngcontent-serverapp-c2101316294
                  className="receive-box ng-tns-c2101316294-28"
                >
                  <div
                    _ngcontent-serverapp-c2101316294
                    className="item ng-tns-c2101316294-28"
                  >
                    <div
                      _ngcontent-serverapp-c2101316294
                      className="receive-bonus ng-tns-c2101316294-28"
                    >
                      <div
                        _ngcontent-serverapp-c2101316294
                        className="text ng-tns-c2101316294-28"
                      >
                        <i
                          id="locale-util-dicrective-9"
                          className="ng-tns-c2101316294-28"
                          style={{ display: "initial" }}
                        >
                          ৳ 0
                        </i>
                      </div>
                      <div
                        _ngcontent-serverapp-c2101316294
                        className="button ng-tns-c2101316294-28 btn-disabled"
                      >
                        {" "}
                        Claim{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mcd-can-receive-bonus>

            <mcd-commission-info
              _nghost-serverapp-c560261221
              className="ng-tns-c560261221-29 ng-tns-c677469450-25 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c560261221
                className="menu-box commission-info ng-tns-c560261221-29 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c560261221
                  className="title ng-tns-c560261221-29"
                >
                  <h2
                    _ngcontent-serverapp-c560261221
                    className="ng-tns-c560261221-29"
                  >
                    <span
                      _ngcontent-serverapp-c560261221
                      className="ng-tns-c560261221-29"
                    >
                      How to earn more rewards
                    </span>
                  </h2>
                </div>
                <div
                  _ngcontent-serverapp-c560261221
                  className="commission-bets-box ng-tns-c560261221-29"
                >
                  <div
                    _ngcontent-serverapp-c560261221
                    className="sec referral-level ng-tns-c560261221-29"
                  >
                    <p
                      _ngcontent-serverapp-c560261221
                      className="ng-tns-c560261221-29"
                    >
                      All referrer will receive certain cash reward percentage
                      for every referee when they play games on Banglabet.
                    </p>
                  </div>
                  <div
                    _ngcontent-serverapp-c560261221
                    className="sec referral-tips ng-tns-c560261221-29"
                  >
                    <img
                      _ngcontent-serverapp-c560261221
                      mcdsrc="/assets/images/player/referral/commission-from.png"
                      alt="commission-from"
                      className="ng-tns-c560261221-29"
                      src="https://img.b426b.com/bb/h5/assets/images/player/referral/commission-from.png?v=1777968966408&source=mcdsrc"
                      loading="lazy"
                    />
                  </div>
                  <div
                    _ngcontent-serverapp-c560261221
                    className="sec referral-tips ng-tns-c560261221-29"
                  >
                    <p
                      _ngcontent-serverapp-c560261221
                      className="ng-tns-c560261221-29"
                    >
                      Be diligent in referring, be the upline and earn up to 3
                      tiers easily!
                    </p>
                    <h2
                      _ngcontent-serverapp-c560261221
                      className="ng-tns-c560261221-29"
                    >
                      Welcome to lifetime commissions!
                    </h2>
                  </div>
                </div>
              </div>
            </mcd-commission-info> */}
          </div>
        </mcd-referral-invite-mobile>
      </div>
    </AccountLayout>
  );
};

export default Refrel;
